// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const communityRouter =
  {
    path:roterPre+ `/community`,
    name: 'community',
    meta: {
      icon: '',
      title: '内容'
    },
    alwaysShow: true,
    component: Layout,
    children: [

      {
        path: 'list',
        name: 'list',
        meta: {
          title: '逛逛社区',
          noCache: true
        },
        component: () => import('@/views/community/communityList/index.vue')
      },
       {
            path: 'list/addContent/:id?/:edit?',
            component: () => import('@/views/community/addContent.vue'),
              name: 'addContent',
              meta: { title: '内容添加', noCache: true, activeMenu: `/merchant/community/list` },
              hidden: true
       }

    ]
  }
export default communityRouter as RouteRecordRaw